import { render, staticRenderFns } from "./zyzzc_zc.vue?vue&type=template&id=e84ed644&scoped=true&"
import script from "./zyzzc_zc.vue?vue&type=script&lang=js&"
export * from "./zyzzc_zc.vue?vue&type=script&lang=js&"
import style0 from "./zyzzc_zc.vue?vue&type=style&index=0&id=e84ed644&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84ed644",
  null
  
)

export default component.exports